import { createSlice } from "@reduxjs/toolkit";

export const idproofSlice = createSlice({
    name : "idproofs",
    initialState:{
        data : [],
        hasChanges: false, 
    },
    reducers : {
        addIdProof: (state, action) => {
            state.data.push(action.payload); 
          },
          deleteIdProof: (state, action) => {
            state.data = state.data.filter((item) => item.id !== action.payload); 
          },
    }
})

export const {addIdProof, deleteIdProof } = idproofSlice.actions;
export default idproofSlice.reducer;